/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSaleDto } from '../../models/backend-actual-sale-dto';
import { BackendPatchedActualSaleRequestDto } from '../../models/backend-patched-actual-sale-request-dto';

export interface MonitoringActualsSalesPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualSaleRequestDto;
}

export function monitoringActualsSalesPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalesPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSaleDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalesPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSaleDto>;
    }),
  );
}

monitoringActualsSalesPartialUpdate$FormData.PATH = '/api/monitoring/actuals/sales/{id}/';
